// §2.6 Review set — Stage: full-bleed, the asset centred on panel; portrait assets letterboxed at 16:9 on desktop,
// full-width at their own ratio on phone. transport sits along the bottom edge.
export default function Stage({ children, transport, label = 'Video' }) {
  return (
    <section className="ui ui-stagearea" aria-label={label}>
      <div className="ui-stagearea__media"><div className="ui-stagearea__box">{children}</div></div>
      {transport}
    </section>
  );
}
